<template>
  <div class="page_recruitDemand">
    <div class="memberTop">
      <div class="memberInput">
        <ShowNavHead />
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>雇员</el-breadcrumb-item>
          <el-breadcrumb-item>设置</el-breadcrumb-item>
          <el-breadcrumb-item>标签管理</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="ftabs">
        <el-tabs v-model="activeName" type="card" @tab-click="handleClick" class="s_tabs_box">
          <el-tab-pane v-if="checkPermission(['employeeSet_tab_divide'],permissionLists)" label="简历资源分配" name="first"></el-tab-pane>
          <!-- <el-tab-pane v-if="checkPermission(['employeeSet_tab_batch'],permissionLists)" label="批量项目设置" name="second"></el-tab-pane> -->
          <el-tab-pane v-if="checkPermission(['employeeSet_tab_label'],permissionLists)" label="标签管理" name="third"></el-tab-pane>
        </el-tabs>
        <labelManage v-if="checkPermission(['employeeSet_tab_label'],permissionLists)"/>
      </div>
    </div>
  </div>
</template>
  
<script>
import xz from "@/common";
import labelManage from "./components/labelManage.vue";
import checkPermission from '@/utils/permission' // 权限判断函数
// import ResourceComTabs from "./components/resourceComTabs.vue"
export default {
  components: {
    labelManage
    // ResourceComTabs
  },
  data() {
    return {
      tableHeight: 0,
      activeName: '',
      tabids: [],
      roleType: localStorage.loginRoletype,
      // 按钮权限参数
      butQuery:{
        path:'/employeeSet',
        powerEnName:'employee'
      },
      permissionLists:[]
    }
  },
  created() {
    this.getButtonPower()
  },
  methods: {
    checkPermission,
    // 获取按钮权限
    getButtonPower(){
      let param = this.$route.query.active
      let that = this
      xz.getbtnPowerIdBypage(this.butQuery).then(res => {
        // console.log('按钮',res)
        if(res.status == 'ok'){
          let resmsg = res.msg
          if(!this.isNull(resmsg)){
            for (let index = 0; index < resmsg.length; index++) {
              let element = resmsg[index];
              this.permissionLists.push(element.Enname);
            }
            if(!this.isNull(param)){//从其它页面跳转过来
              that.activeName = param
              if(that.activeName == 'first'){
                that.$router.push({
                    path: '/employeeSet',
                    query:{
                        active:'first'
                    }
                })
              }
              if(that.activeName == 'second'){
                that.$router.push({
                    path: '/employeeSet',
                    query:{
                        active:'second'
                    }
                })
              }
            }else{
              if((that.checkPermission(['employeeSet_tab_divide'],that.permissionLists))){
                that.$router.push({
                    path: '/employeeSet',
                    query:{
                        active:'first'
                    }
                })
              }else if((!that.checkPermission(['employeeSet_tab_divide'],that.permissionLists))&&(that.checkPermission(['employeeSet_tab_batch'],that.permissionLists))){
                that.$router.push({
                    path: '/employeeSet',
                    query:{
                        active:'second'
                    }
                })
              }else if((!that.checkPermission(['employeeSet_tab_divide'],that.permissionLists))&&(!that.checkPermission(['employeeSet_tab_batch'],that.permissionLists))&&(that.checkPermission(['employeeSet_tab_label'],that.permissionLists))){
                that.activeName = 'third'
              }
            }
          }else{
            this.permissionLists = []
            this.activeName = ''
          }
        }else{
          this.permissionLists = []
          this.activeName = ''
        }
      })
    },
    //判断是否为空(包含0)或1970
    isNull(o) {
      return o == undefined || o == "undefined" || (o + '').indexOf("undefined") > -1 || o == null || o == '' || o == 'null' || o == [] || o == 0;
    },
    handleClick(tab){
        // console.log('dd',tab)
        this.activeName = tab.name
        if(tab.name == 'second'||tab.name == 'first'){
            this.$router.push({
                path: '/employeeSet',
                query:{
                    active: tab.name
                }
            })
        }
    }
  }
}
</script>

<style scoped>
.ftabs {
  background: #fff;
  width: 99%;
}
</style>

<style >
</style>